import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:5005";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
 /*  headers: {
    "Content-Type": "application/json",
  }, */
});

// ---- REQUEST INTERCEPTOR ----
// Runs before every single request. Attaches the JWT token automatically,
// so you never have to manually add "Authorization: Bearer ..." in every page.
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// ---- RESPONSE INTERCEPTOR ----
// Runs after every response. If the token is invalid/expired (401),
// automatically log the admin out and send them back to login —
// instead of every single page having to check for this manually.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("admin_user");

      if (
        window.location.pathname.startsWith("/admin") &&
        window.location.pathname !== "/admin/login"
      ) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
